/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { _ } from './i18n';
import { DocType } from '../api/documents/documentsClient.typings';

export const DOC_TYPE_L10N: { [key in DocType]: string } = {
    [DocType.Sale]: _('document.type.Sale'),
    [DocType.ZReport]: _('document.type.ZReport'),
    [DocType.MoneyBack]: _('document.type.MoneyBack'),
    [DocType.RollBack]: _('document.type.RollBack'),
    [DocType.Correction]: _('document.type.Correction'),
    [DocType.OpenShift]: _('document.type.OpenShift'),
    [DocType.Prepayment]: _('document.type.Prepayment'),
    [DocType.CreditPay]: _('document.type.CreditPay'),
};

export const PARENT_DOC_LABEL_BY_TYPE: { [key in DocType]?: string } = {
    [DocType.Sale]: 'document.parentFiscalIdLabels.saleFiscalId',
    [DocType.Prepayment]: 'document.parentFiscalIdLabels.prepayFiscalId',
    [DocType.CreditPay]: 'document.parentFiscalIdLabels.creditpayFiscalId',
    [DocType.Correction]: 'document.parentFiscalIdLabels.correctionFiscalId',
    [DocType.MoneyBack]: 'document.parentFiscalIdLabels.moneybackFiscalId',
};
